import React from "react";
import { Box } from "@material-ui/core";
import Logo from "../../common/Logo";

const LoginFormLogo: React.FC = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      alignContent="center"
      justifyContent="center"
      mt={3}
      mb={1}
    >
      <Logo />
    </Box>
  );
};

export default LoginFormLogo;
